"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiService = void 0;
var ApiService = /** @class */ (function () {
    function ApiService(api) {
        this.api = api;
    }
    ApiService.prototype.url = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        args.unshift(this.endpoint);
        return args.filter(Boolean).join('/');
    };
    ApiService.prototype.getCollectionRequest = function (url, config) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            return _this.api.client
                .get(url, config)
                .then(function (res) { return resolve(res.data); })
                .catch(function (err) { return reject(err); });
        });
    };
    ApiService.prototype.getRequest = function (url, config) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.api.client
                .get(url, config)
                .then(function (res) { var _a; return resolve(((_a = res.data) === null || _a === void 0 ? void 0 : _a.data) || res.data); })
                .catch(function (err) { return reject(err); });
        });
    };
    ApiService.prototype.postRequest = function (url, data, config) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            return _this.api.client
                .post(url, data, config)
                .then(function (res) { var _a, _b; return resolve((((_a = res.data) === null || _a === void 0 ? void 0 : _a.data) || ((_b = res.data) === null || _b === void 0 ? void 0 : _b.message) || res.data)); })
                .catch(function (err) { return reject(err); });
        });
    };
    ApiService.prototype.putRequest = function (url, data, config) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.api.client
                .put(url, data, config)
                .then(function (res) { var _a; return resolve((((_a = res.data) === null || _a === void 0 ? void 0 : _a.data) || res.data)); })
                .catch(function (err) { return reject(err); });
        });
    };
    ApiService.prototype.patchRequest = function (url, data, config) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.api.client
                .patch(url, data, config)
                .then(function (res) { var _a; return resolve((_a = res.data) === null || _a === void 0 ? void 0 : _a.data); })
                .catch(function (err) { return reject(err); });
        });
    };
    ApiService.prototype.deleteRequest = function (url, config) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.api.client
                .delete(url, config)
                .then(function (res) { var _a; return resolve((_a = res.data) === null || _a === void 0 ? void 0 : _a.data); })
                .catch(function (err) { return reject(err); });
        });
    };
    return ApiService;
}());
exports.ApiService = ApiService;
//# sourceMappingURL=api-service.js.map